// src/pages/NotFound.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function NotFound() {
  const { t } = useTranslation();

  return (
    <main className="notfound-page">
      <div className="notfound-content">
        <div className="notfound-number">404</div>
        <h1>{t('notFound.title')}</h1>
        <p>{t('notFound.text')}</p>

        <div className="notfound-actions">
          <Link to="/" className="btn btn-primary">{t('notFound.backHome')}</Link>
          <Link to="/boutique" className="btn btn-secondary">{t('notFound.discoverShop')}</Link>
        </div>

        <div className="notfound-links">
          <p>{t('notFound.maybeLooking')}</p>
          <div className="notfound-categories">
            <Link to="/capes">{t('notFound.linkCapes')}</Link>
            <Link to="/ensembles">{t('notFound.linkSets')}</Link>
            <Link to="/abayas">{t('notFound.linkAbayas')}</Link>
            <Link to="/burkinis">{t('notFound.linkBurkinis')}</Link>
            <Link to="/contact">{t('notFound.linkContact')}</Link>
          </div>
        </div>
      </div>
    </main>
  );
}

export default NotFound;